import { Endpoints } from '@/api/ApiEndpoints';
import router from '@/router';
import { Inputs,validationSchema } from '@/entities/Markets/MarketsFormInputs'

const Markets = {
	Plural: 'Markets',
	Single: 'Market',
	Inputs: Inputs,	
	Relationships: [
		
	],
	ValidationSchema: validationSchema,
	SaveCallBack: (id) =>{ 
		//router.push(`/leagues/edit/${id}`)
	}
};

export default Markets;
